import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListCraComponent } from './components/list-cra/list-cra.component';
import { WorkflowCraComponent } from './components/workflow-cra/workflow-cra.component';
import { ValidCraComponent } from './components/valid-cra/valid-cra.component';
import { ListWorkflowComponent } from './components/list-workflow/list-workflow.component';
import { WorkflowClientconsultantComponent } from './components/workflow-clientconsultant/workflow-clientconsultant/workflow-clientconsultant.component';
import { WorkflowConsultantComponent } from './components/workflow-consultant/workflow-consultant/workflow-consultant.component';
import { UpdateWorkflowComponent } from './components/update-workflow/update-workflow/update-workflow.component';
import { DetailWorkflowgenComponent } from './components/detail-workflowgen/detail-workflowgen/detail-workflowgen.component';
import { esnAbonneeGuard } from '@core/guards/esn-abonnee.guard';
import { IntervenerRoleGuard } from '@core/guards/intervener-role.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: ListCraComponent,
    canActivate: [esnAbonneeGuard.canActivate]
  },
  {
    path: 'modifierworkflow/:id',
    component: UpdateWorkflowComponent,
    canActivate: [IntervenerRoleGuard]
  },
  {
    path: 'DetailWorkflow/:id',
    component: DetailWorkflowgenComponent,
  },
  {
    path: 'workflow',
    component: WorkflowCraComponent,
  },
  {
    path: 'workflowclient',
    component: WorkflowClientconsultantComponent,
    canActivate: [IntervenerRoleGuard]
  },
  {
    path: 'workflowConsultant',
    component: WorkflowConsultantComponent,
    canActivate: [IntervenerRoleGuard]
  },
  {
    path: 'valide-cra',
    component: ValidCraComponent,
  },
  {
    path: 'list-workflow',
    component: ListWorkflowComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CraRoutingModule {}
